import { render, staticRenderFns } from "./ReviewAndConfirmIS.vue?vue&type=template&id=08255aae"
import script from "./ReviewAndConfirmIS.vue?vue&type=script&lang=js"
export * from "./ReviewAndConfirmIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports